module.exports = __webpack_public_path__ + "media/images/profile/edit-01f625abb3ac67133a5187fa40fb9224.svg";